import styled from 'styled-components';

const LogoDiv = styled.div`
  display: flex;
  justify-content: flex-start;
  align-self: center;
`;

export default LogoDiv;
